import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { SupportWebsiteNavOld } from './ui/index.tsx';

const LazySupportWebsiteNav = lazyForPaint<typeof SupportWebsiteNavOld>(() =>
	import(/* webpackChunkName: "async-support-site-nav" */ './ui').then(
		({ SupportWebsiteNavOld }) => SupportWebsiteNavOld,
	),
);

export const AsyncSupportWebsiteNav = () => (
	<Placeholder name="horizontal-csm-support-site-nav" fallback={null}>
		<LazySupportWebsiteNav />
	</Placeholder>
);
